import React, { useEffect, useRef, useState } from "react";
import IncidentReportFilter from "../shared/IncidentReportFilter";
import GridTable from "../../../library/custom/gridTable/GridTable";
import {
  INCIDENT_LIST_COLOUMNS,
  INCIDENT_TYPE,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
} from "../../../constant/constant";
import TableRowAction from "../../../library/custom/gridTable/TableRowAction";
import DialogIncidentBox from "../../../library/common/CloseDialogBox";
import { useNavigate } from "react-router-dom";
import {
  NEAR_MISS,
  PERSONAL_INJURY,
  PROPERTY_DAMAGE,
  STOLEN_PROPERTY,
  UTILITY_DAMAGE,
  VEHICLE_ACCIDENT,
  VIEW_INCIDENT_REPORT,
} from "../../../constant/routeContant";
import { TableLoader } from "../../../library/common/Loader";
import NORow from "../../../library/custom/noRow/noRow";
import downloadIcon from "../../../assets/downloadIcon.svg";
import { InactiveClient } from "../../../utils/helper";
import { useDebounce } from "../../../utils/useDebounceSearch";

const IncidentList = ({
  incidentList,
  getIncidentListData,
  deleteIncidents,
  isLoader,
  isFullAccess,
  isWriteAccess,
  isReadAccess,
  closeIncidents,
  incidentListdata,
  shouldRestoreState,
  hasBaseDivisionAdminAccess,
  baseDivisionIds,
}) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [anchorEl, setAnchorEl] = useState(null);
  const [incSearchText, setIncSearchText] = useState("");
  const debouncedSearch = useDebounce(incSearchText, 500);
  const [incidentFilterData, setIncidentFilterData] = useState({});
  const [isTableLoading, setisTableLoading] = useState(false);

  // Keep division-admin division scope on every request (matches project list page)
  const withDivisionGuard = (data) => ({
    ...data,
    divisionId:
      hasBaseDivisionAdminAccess && baseDivisionIds?.length
        ? baseDivisionIds
        : (data?.divisionId ?? ""),
  });

  const resetData = () => {
    setPage(0);
    setPageSize(PAGE_SIZE);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setIncSearchText();
    setIncidentFilterData({});
    getIncidentListData(
      withDivisionGuard({ pageNumber: 1, isSendMail: false }),
    );
  };

  const navigate = useNavigate();
  const columns = React.useMemo(() => {
    const headers = [...INCIDENT_LIST_COLOUMNS];
    headers.push({
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <TableRowAction
            rows={rows}
            actionData={["View Details", "Edit Incident", "Delete Incident"]}
            usingComp={"Incident"}
            edit={isFullAccess || isWriteAccess}
            view={isReadAccess || isFullAccess || isWriteAccess}
            deleted={isFullAccess}
            editLabel={"Edit Incident"}
            viewLabel={"View Incident"}
            deleteLabel={"Delete Incident"}
            CloseIncident={
              (rows?.row?.statusId !== "1" && rows?.row?.statusId !== "3"
                ? true
                : false) &&
              (isFullAccess || isWriteAccess)
            }
            CloseIncidentLabel={"Close Incident"}
            viewOnClick={(currentRow) => handleViewOnClick(currentRow)}
            editOnClick={(currentRow) => handleEditOnclick(currentRow)}
            deleteOnClick={() => deleteIncident(rows?.row)}
            closeOnClick={() => {
              if (InactiveClient()) return;
              closeIncidentHandler(rows?.row);
            }}
          />
        );
      },
    });
    return headers;
  }, []);

  const handleClose = (event) => {
    event?.currentTarget.type === "button"
      ? setAnchorEl(event.currentTarget)
      : setAnchorEl(null);
  };

  const handleSearchFilter = (event, state) => {
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setAnchorEl(null);
    setIncidentFilterData(state);
    const data = {
      ...state,
      pageNumber: 1,
      searchText: incSearchText,
      pageSize: pageSize,
      isSendMail: false,
    };
    getIncidentListData(withDivisionGuard(data));
  };

  const handleInputSearch = (e) => {
    let searchitm = "";
    if (e.target.value) {
      searchitm = e.target.value;
    }
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setIncSearchText(searchitm);
  };

  //pagination
  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    getIncidentListData(
      withDivisionGuard({
        ...incidentFilterData,
        searchText: incSearchText,
        isSendMail: false,
        pageNumber: 1,
        pageSize: newPazeSize,
      }),
    );
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    getIncidentListData(
      withDivisionGuard({
        ...incidentFilterData,
        pageNumber: newPage + 1,
        pageSize: pageSize,
        searchText: incSearchText,
        isSendMail: false,
      }),
    );
  };

  const handleEditOnclick = (rows) => {
    if (InactiveClient()) return;
    if (rows?.incidentId === 2) {
      navigations(
        VEHICLE_ACCIDENT,
        rows?.reportId,
        rows?.caseId,
        rows?.incidentId,
        rows?.statusId,
      );
    } else if (rows?.incidentId === 1) {
      navigations(
        PERSONAL_INJURY,
        rows?.reportId,
        rows?.caseId,
        rows?.incidentId,
        rows?.statusId,
      );
    } else if (rows?.incidentId === 4) {
      navigations(UTILITY_DAMAGE, rows?.reportId, rows?.caseId, rows?.statusId);
    } else if (rows?.incidentId === 3) {
      navigations(
        STOLEN_PROPERTY,
        rows?.reportId,
        rows?.caseId,
        rows?.incidentId,
        rows?.statusId,
      );
    } else if (rows?.incidentId === 5) {
      navigations(
        NEAR_MISS,
        rows?.reportId,
        rows?.caseId,
        rows?.incidentId,
        rows?.statusId,
      );
    } else if (rows?.incidentId === 10) {
      navigations(
        PROPERTY_DAMAGE,
        rows?.reportId,
        rows?.caseId,
        rows?.incidentId,
        rows?.statusId,
      );
    }
  };

  const handleViewOnClick = (rows) => {
    if (
      rows?.incidentId === 2 ||
      rows?.incidentId === 1 ||
      rows?.incidentId === 3 ||
      rows?.incidentId === 4 ||
      rows?.incidentId === 5 ||
      rows?.incidentId === 10
    ) {
      navigations(
        VIEW_INCIDENT_REPORT,
        rows?.reportId,
        rows?.caseId,
        rows?.incidentId,
        rows?.statusId,
      );
    }
  };

  const [openIncidentModal, setOpenIncidentModal] = useState(false);
  const [selectedIncidentRow, setSelectedIncidentRow] = useState("");
  const [actionIds, setActionIds] = useState();
  const [closeDeleteMode, setCloseDeleteMode] = useState(1);

  const closehandle = () => {
    setOpenIncidentModal(false);
    closeIncidents(selectedIncidentRow);
  };

  const closeIncidentHandler = (rows) => {
    setOpenIncidentModal(true);
    setSelectedIncidentRow(rows);
    setActionIds(rows);
    setCloseDeleteMode(1);
  };

  const deletehandle = () => {
    setOpenIncidentModal(false);
    deleteIncidents(selectedIncidentRow);
  };

  const deleteIncident = (rows) => {
    if (InactiveClient()) return;
    setOpenIncidentModal(true);
    setSelectedIncidentRow(rows);
    setActionIds(rows);
    setCloseDeleteMode(2);
  };

  function navigations(
    navigationPath,
    incidentId,
    caseId,
    incidentType,
    statusId,
  ) {
    sessionStorage.setItem("incidentListPreserveState", "true");
    navigate(navigationPath, {
      state: {
        caseId: caseId,
        incidentId: incidentId,
        editMode: true,
        isDirect: true,
        incidentType: incidentType,
        statusId: statusId,
      },
    });
  }
  const onRowClick = (rows) => {
    if (rows.value) {
      handleViewOnClick(rows?.row);
    }
  };

  const sendEmail = () => {
    getIncidentListData(
      withDivisionGuard({
        ...incidentFilterData,
        pageNumber: page,
        searchText: incSearchText,
        isSendMail: true,
      }),
    );
  };

  useEffect(() => {
    if (shouldRestoreState === null) return;
    if (shouldRestoreState === true && incidentListdata?.filterObj) {
      const f = incidentListdata.filterObj;
      setIncSearchText(f.searchText || "");
      setPage((f.pageNumber || 1) - 1);
      setPageSize(f.pageSize || PAGE_SIZE);
      const { searchText, pageNumber, pageSize, isSendMail, ...restData } = f;
      setIncidentFilterData(restData || {});
    } else if (
      shouldRestoreState === false ||
      (shouldRestoreState === true && !incidentListdata?.filterObj)
    ) {
      setIncSearchText("");
      setPage(0);
      setPageSize(PAGE_SIZE);
      setIncidentFilterData({});
    }
  }, [shouldRestoreState]);

  // Reset local state when filterObj is reset after delete/close operations
  useEffect(() => {
    if (incidentListdata?.filterObj) {
      const f = incidentListdata.filterObj;
      // Check if filterObj has been reset (only has pageNumber and isSendMail)
      const isReset =
        f.pageNumber === 1 && !f.searchText && Object.keys(f).length <= 3; // pageNumber, isSendMail, and possibly pageSize

      if (isReset) {
        setIncSearchText("");
        setPage(0);
        setPageSize(PAGE_SIZE);
        setIncidentFilterData({});
      }
    }
  }, [incidentListdata?.filterObj]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
    getIncidentListData(
      withDivisionGuard({
        ...incidentFilterData,
        pageNumber: 1,
        searchText: debouncedSearch ? debouncedSearch : "",
        pageSize: pageSize,
        isSendMail: false,
      }),
    );
  }, [debouncedSearch]);

  return (
    <>
      <section className="grid_main_sec">
        {openIncidentModal && (
          <DialogIncidentBox
            open={openIncidentModal}
            rows={[]}
            header={
              parseInt(closeDeleteMode) === 1
                ? "Close Incident"
                : "Delete Incident"
            }
            warningImg={parseInt(closeDeleteMode) === 2}
            closehandle={
              parseInt(closeDeleteMode) === 1 ? closehandle : deletehandle
            }
            handleCloseModal={() => setOpenIncidentModal(false)}
            content={
              parseInt(closeDeleteMode) === 1
                ? actionIds?.actionIds?.length > 0
                  ? `Following Action items ID: [${actionIds?.actionIds}] are still in open status, Do you still want to close this Incident?`
                  : "No open action items associated with this incident"
                : actionIds?.actionIds?.length > 0
                  ? `Following Action items ID: [${actionIds?.actionIds}] are still in open status, Do you still want to Delete this Incident?`
                  : "No open action items associated with this incident"
            }
            view
          />
        )}

        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">View Incident Reports</div>
        </div>
        <div className="grid_main_body">
          <div className="div-filter-container">
            <IncidentReportFilter
              filterType={INCIDENT_TYPE ?? []}
              handleSearchFilter={handleSearchFilter}
              handleClose={handleClose}
              anchorEl={anchorEl}
              incReport={incSearchText}
              handleInputSearch={handleInputSearch}
              resetFilterAPI={resetData}
              setAnchorEl={setAnchorEl}
              singleSelect={true}
              singleCheckbox={false}
              incidentListdata={incidentListdata}
            />
            <div className="div-download-email-right" onClick={sendEmail}>
              <span>
                <img
                  src={downloadIcon}
                  className="DownLoadLogo"
                  alt="DownLoad Logo"
                />
              </span>
              Download Data
            </div>
          </div>
        </div>

        <div className="desc_box row_uniq">
          <div className="table_style_ui">
            {isTableLoading ? (
              ""
            ) : (
              <GridTable
                getRowId={(r) => r.reportId}
                rows={incidentList?.incident ?? []}
                columns={columns}
                rowCount={incidentList?.noOfRecords ?? 0}
                checkboxSelection={false}
                page={page}
                onClick={(rows) => onRowClick(rows)}
                pagination
                loading={isLoader}
                pageSize={pageSize}
                rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePagignation}
                backIconButtonProps={{ disabled: false }}
                disableSelectionOnClick
                components={{
                  LoadingOverlay: TableLoader,
                  NoRowsOverlay: NORow,
                }}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default IncidentList;
